
import Modal from "react-modal"
import React, { useEffect } from "react";
import { useForm, FormContext } from 'react-hook-form';
import classNames from 'classnames';

import {
  useCreateExhibitorMutation,
  useUpdateExhibitorMutation,
  ExhibitorModel,
} from '../../../api'

import {
  EditExhibitorForm,
  EditExhibitorSchema,
} from '../../../schema'

import { updateFieldsByPostalCode } from '../../../utils'

import countriesPath from '../../../assets/csv/countries.csv'
import exhibitionsPath from '../../../assets/csv/exhibitions.csv'

const countriesReq = new XMLHttpRequest();
countriesReq.open("get", countriesPath, true);
countriesReq.send();
let countries: string[] = [];
countriesReq.onload = function(){
  countries = countriesReq.responseText.split("\n")
}

const exhibitionsReq = new XMLHttpRequest();
exhibitionsReq.open("get", exhibitionsPath, true);
exhibitionsReq.send();
let exhibitions: string[] = [];
exhibitionsReq.onload = function(){
  exhibitions = exhibitionsReq.responseText.split("\n")
}

Modal.setAppElement("#root")

interface Props {
  type?: 'create' | 'readonly';
  exhibitor?: ExhibitorModel;
  isOpen: boolean;
  handleCloseModal(): void;
  handleSubmit(): void;
}

const EditExhibitorModal = (props: Props) => {
  const [createExhibitorMutation] = useCreateExhibitorMutation();
  const [updateExhibitorMutation] = useUpdateExhibitorMutation();
  const { exhibitor, type } = props


  const formMethods = useForm<EditExhibitorForm>({
    validationSchema: EditExhibitorSchema,
  })
  const { register, handleSubmit, errors, reset, setValue } = formMethods

  setTimeout(() => {
    if (!exhibitor?.boothsCount) setValue('boothsCount', 0);
  })

  useEffect(() => {
    if (exhibitor) {
      reset(exhibitor as any)
    }
  }, [reset, exhibitor])

  const onSubmit = async (formData: EditExhibitorForm) => {
    if (type === 'create') {
      await createExhibitorMutation({
        variables: { input: {...formData} },
      })
    } else {
      await updateExhibitorMutation({
        variables: { id: exhibitor!.id, input: {...formData} },
      })
    }
    props.handleSubmit()
  }

  return (
    <div className="modal">
      <Modal
          isOpen={props.isOpen}
          className="modal-dialog"
          overlayClassName="Overlay"
          onRequestClose={props.handleCloseModal}
      >
        <div className="modal-content update-modal">
          <div className="modal-header">
            <button type="button" className="close" onClick={props.handleCloseModal}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <FormContext {...formMethods}>
              <form onSubmit={handleSubmit(onSubmit)} className="">
                <h3>アカウント情報</h3>
                <div className="form-section">
                  <div className="form-group">
                    <label>ログインID</label> 

                    <input
                      ref={register}
                      name="accountId"
                      type="text"
                      disabled={type !== 'create'}
                      className={classNames("form-control", { 'is-invalid': errors.accountId?.type === 'required', })} />
                    {
                      errors.accountId &&
                      <div className="invalid-feedback">
                        ※ログインIDを入力してください。
                      </div>
                    }
                  </div>
                </div>
                
                <div className="form-section">
                  <div className="form-group">
                    <label>パスワード</label> 

                    <input
                      ref={register}
                      name="password"
                      type="text"
                      disabled={type !== 'create'}
                      className={classNames("form-control", { 'is-invalid': errors.password?.type === 'required', })} />
                    {
                      errors.password &&
                      <div className="invalid-feedback">
                        ※パスワードを入力してください。
                      </div>
                    }
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-group">
                    <label>展示会</label> 

                    <select ref={register} name="exhibition" disabled={type !== 'create'} className={classNames("form-control", { 'is-invalid': errors.exhibition?.type === 'required', })}>
                      {exhibitions.map(exhibition => <option value={exhibition} key={exhibition}>
                        {exhibition}
                      </option>)}
                    </select>
                    {
                      errors.accountId &&
                      <div className="invalid-feedback">
                        ※展示会を選択してください。
                      </div>
                    }
                  </div>
                </div>
                
                <h3>出展者基本情報</h3>

                <div className="row">
                  {/* <div className="col-6 text-center"><b>日本語表記</b></div>
                  <div className="col-6 text-center"><b>Written in English</b></div> */}
                </div>

                <div className="form-section">
                  <div className="form-group">
                    <label>構成展</label> 

                    <input
                      ref={register}
                      name="composition"
                      type="text"
                      className="form-control" 
                      disabled={type === 'readonly'} />
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-group">
                    <label>国名{/*  / Country */}</label> 

                    <select ref={register} name="country" className="form-control" disabled={type === 'readonly'}>
                      {countries.map(country => <option value={country} key={country}>
                        {country}
                      </option>)}
                    </select>
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-12">
                    <div className="form-section">
                      <div className="form-group">
                        <label>社名</label> 

                        <input
                          ref={register}
                          name="companyName"
                          type="text"
                          className="form-control" 
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                  <div className="col-6" style={{display: 'none'}}>
                    <div className="form-section">
                      <div className="form-group">
                        <label>Company Name</label> 

                        <input
                          ref={register}
                          name="companyNameEn"
                          type="text"
                          className="form-control" 
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-group">
                    <label>社名カナ</label> 

                    <input
                      ref={register}
                      name="companyNameKana"
                      type="text"
                      className="form-control" 
                      disabled={type === 'readonly'} />
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="form-section">
                      <div className="form-group">
                        <label>部署</label> 

                        <input
                          ref={register}
                          name="department"
                          type="text"
                          className="form-control" 
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                  <div className="col-6" style={{display: 'none'}}>
                    <div className="form-section">
                      <div className="form-group">
                        <label>Department</label> 

                        <input
                          ref={register}
                          name="departmentEn"
                          type="text"
                          className="form-control" 
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="form-section">
                      <div className="form-group">
                        <label>役職</label> 

                        <input
                          ref={register}
                          name="position"
                          type="text"
                          className="form-control" 
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                  <div className="col-6" style={{display: 'none'}}>
                    <div className="form-section">
                      <div className="form-group">
                        <label>Position</label> 

                        <input
                          ref={register}
                          name="positionEn"
                          type="text"
                          className="form-control" 
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="form-section">
                  <div className="form-group">
                    {// Number of booths
                    }
                    <label>小間数</label> 

                    <input
                      ref={register}
                      name="boothsCount"
                      type="number"
                      className="form-control" 
                      disabled={type === 'readonly'} />
                  </div>
                </div> */}

                <div className="form-section">
                  <div className="form-group">
                    <label>受付No.{/*  / Reception Number */}</label> 

                    <input
                      ref={register}
                      name="receptionId"
                      type="text"
                      className="form-control" 
                      disabled={type === 'readonly'} />
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="form-section">
                      <div className="form-group">
                        <label>出展担当者姓</label> 

                        <input
                          ref={register}
                          name="familyName"
                          type="text"
                          className="form-control" 
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                  <div className="col-6" style={{display: 'none'}}>
                    <div className="form-section">
                      <div className="form-group">
                        <label>Family Name</label> 

                        <input
                          ref={register}
                          name="familyNameEn"
                          type="text"
                          className="form-control" 
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="form-section">
                      <div className="form-group">
                        <label>出展担当者名</label> 

                        <input
                          ref={register}
                          name="givenName"
                          type="text"
                          className="form-control" 
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                  <div className="col-6" style={{display: 'none'}}>
                    <div className="form-section">
                      <div className="form-group">
                        <label>Given Name</label> 

                        <input
                          ref={register}
                          name="givenNameEn"
                          type="text"
                          className="form-control" 
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-group">
                    <label>メールアドレス{/*  / Email */}</label> 

                    <input
                      ref={register}
                      name="email"
                      type="text"
                      className="form-control" 
                      disabled={type === 'readonly'} />
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-group">
                    <label>電話番号{/*  / Telephone number */}</label> 

                    <input
                      ref={register}
                      name="tel"
                      type="text"
                      className="form-control" 
                      disabled={type === 'readonly'} />
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-group">
                    <label>郵便番号{/*  / Postal code */}</label> 

                    <input
                      ref={register}
                      name="postalCode"
                      type="text"
                      className="form-control"
                      onChange={(e) => {updateFieldsByPostalCode(e.target.value, setValue)}}
                      size={8}
                      disabled={type === 'readonly'} />
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="form-section">
                      <div className="form-group">
                        <label>都道府県</label> 

                        <input
                          ref={register}
                          name="prefecture"
                          type="text"
                          className="form-control"
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                  <div className="col-6" style={{display: 'none'}}>
                    <div className="form-section">
                      <div className="form-group">
                        <label>Prefecture</label> 

                        <input
                          ref={register}
                          name="prefectureEn"
                          type="text"
                          className="form-control"
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="form-section">
                      <div className="form-group">
                        <label>以下住所</label> 

                        <input
                          ref={register}
                          name="municipality"
                          type="text"
                          className="form-control" 
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                  <div className="col-6" style={{display: 'none'}}>
                    <div className="form-section">
                      <div className="form-group">
                        <label>Municipality</label> 

                        <input
                          ref={register}
                          name="municipalityEn"
                          type="text"
                          className="form-control"
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="form-section">
                      <div className="form-group">
                        <label>ビル名</label> 

                        <input
                          ref={register}
                          name="address"
                          type="text"
                          className="form-control"
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                  <div className="col-6" style={{display: 'none'}}>
                    <div className="form-section">
                      <div className="form-group">
                        <label>Address</label> 

                        <input
                          ref={register}
                          name="addressEn"
                          type="text"
                          className="form-control" 
                          disabled={type === 'readonly'} />
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="form-section submit">
                  {type === 'readonly' &&
                    <div className="btn" onClick={props.handleCloseModal}>OK</div>
                  }
                  {type !== 'readonly' &&
                    <input
                      type="submit"
                      name="submit"
                      className="btn"
                      value={type !== 'create' ? "更新" : "作成"} />
                  }
                </div>
              </form>
            </FormContext>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default EditExhibitorModal